import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { Form, Field, reduxForm, SubmissionError } from 'redux-form'
import { PulseLoader } from 'halogen'
import * as MabnaButton from '../common/Button/Button'
import { CONFIRM_SMS_CODE_REQUEST } from '../../actions/actions'
import { appendToFormData, flattenArray } from '../../helpers/utility'

const styles = {
  spinner: {
    height: 45,
    margin: '20px 0',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

class ConfirmResetPassBySms extends Component {
  constructor(props) {
    super(props)
    this.state = {
      aSyncCall: false,
    }
  }

  componentWillMount = () => {
    if (!this.props.resetData) {
      browserHistory.push('/signup/reset-password')
    }
  }

  code = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <div className="reset-pass">
        <input
          type="text"
          className="border-focus-blue"
          placeholder="کد پیامک شده"
          {...input}
          {...custom}
        />
        <div className="form-error">{hasError && error}</div>
      </div>
    )
  }

  new_password = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <div className="reset-pass">
        <input
          type="password"
          className="border-focus-blue"
          placeholder="گذرواژه جدید"
          {...input}
          {...custom}
        />
        <div className="form-error">{hasError && error}</div>
      </div>
    )
  }

  confirm_new_password = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <div className="reset-pass">
        <input
          type="password"
          className="border-focus-blue"
          placeholder="تکرار گذرواژه جدید"
          {...input}
          {...custom}
        />
        <div className="form-error">{hasError && error}</div>
      </div>
    )
  }

  onSubmit = values => {
    const {
      dispatch,
      resetData: { username, token },
    } = this.props

    const formData = appendToFormData({
      token,
      username,
      new_password: values.new_password,
      code: values.code,
    })

    this.setState({ aSyncCall: true })

    return new Promise((resolve, reject) => {
      dispatch({
        type: CONFIRM_SMS_CODE_REQUEST,
        formData,
        resolve,
        reject,
      })
    })
      .then(() => {
        browserHistory.push('/signup/reset-password/by-sms/success')
      })
      .catch(errors => {
        this.setState({ aSyncCall: false })
        throw new SubmissionError(errors)
      })
  }

  render() {
    const { handleSubmit, error } = this.props
    const flattenedErrors = error ? flattenArray(error) : []

    return (
      <div className="signup-success text-center">
        <h4>
          یک کد امنیتی به تلفن همراه شما پیامک شده است. آن کد را به همراه گذرواژه جدید
          وارد کنید
        </h4>

        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <div className="form-error">{flattenedErrors}</div>
          <Field name="code" component={this.code} />
          <Field name="new_password" component={this.new_password} />
          <Field name="confirm_new_password" component={this.confirm_new_password} />

          <MabnaButton.Primary
            style={{ marginRight: 20 }}
            onClick={() => browserHistory.push('/signup/reset-password/by-sms')}
          >
            کد را دریافت نکرده ام
          </MabnaButton.Primary>

          {!this.state.aSyncCall ? (
            <MabnaButton.Primary type="submit" active>
              ثبت گذرواژه جدید
            </MabnaButton.Primary>
          ) : (
            <div style={styles.spinner}>
              <PulseLoader color="#275C8A" size="10px" />
            </div>
          )}
        </Form>
      </div>
    )
  }
}

const validate = values => {
  let errors = {}

  if (!values.code) {
    errors.code = 'وارد کردن کد پیامک شده اجباری است'
  }

  if (!values.new_password) {
    errors.new_password = 'گذرواژه جدید اجباری است'
  }

  if (!values.confirm_new_password) {
    errors.confirm_new_password = 'تایید گذرواژه الزامی است'
  }

  if (values.confirm_new_password !== values.new_password) {
    errors.confirm_new_password = 'گذرواژه و تایید آن باید یکسان باشند'
  }

  return errors
}

ConfirmResetPassBySms = reduxForm({
  form: 'ConfirmResetPassBySms',
  validate,
})(ConfirmResetPassBySms)

const mapStateToProps = state => ({
  resetData: state.auth.resetData,
})

export default connect(mapStateToProps)(ConfirmResetPassBySms)



// WEBPACK FOOTER //
// ./src/components/authentication/ConfirmResetPassBySms.js